import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { ApplicationResponse } from "@src/common/domain/common.model";
import api from "@src/common/services/api.service";
import AppConstants from "@src/utils/app.constants";
import { UsersListModel, UsersStore } from "../../views/users/domain/users.model";



export const fetchUsers =
    createAsyncThunk<any[], void>("users/fetchUsers",
        async () => {
            const url = `${AppConstants.api}/customers`
            const response = await api.get<any[]>(url)
            return response.data
        })

export const createCustomer = createAsyncThunk(
    "users/createCustomer",
    async (customerData: { displayName: string }, { rejectWithValue }) => {
      try {
        const response = await api.post<ApplicationResponse<UsersListModel>>(
          `${AppConstants.api}/customers`,
          customerData
        );
        return response.data.data;
      } catch (err) {
        console.error("Create Customer Error:", err);
        return rejectWithValue("Failed to create customer");
      }
    }
  );
  
  // UPDATE
  export const updateCustomer = createAsyncThunk(
    "users/updateCustomer",
    async (
      { id, customerData }: { id: string; customerData: { displayName: string } },
      { rejectWithValue }
    ) => {
      try {
        const response = await api.put<ApplicationResponse<UsersListModel>>(
          `${AppConstants.api}/customers/${id}`,
          customerData
        );
        return response.data.data;
      } catch (err) {
        console.error("Update Customer Error:", err);
        return rejectWithValue("Failed to update customer");
      }
    }
  );
  
export const deleteUser = createAsyncThunk(
    "users/deleteUser",
    async (id: string, { rejectWithValue }) => {
        try {
            const response = await api.delete<ApplicationResponse<any[]>>(
                `${AppConstants.api}/customers/${id}`
            );
            return response.data.data || [];
        } catch (err) {
            console.error("Delete User Error:", err);
            return rejectWithValue("Failed to delete user");
        }
    }
);

const initialState: UsersStore = {
    minimal: { status: "idle", error: null, data: [] },
};

const usersSlice = createSlice({
    name: "users",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchUsers.pending, (state) => {
                state.minimal.status = "loading";
                state.minimal.data = [];
                state.minimal.error = null;
            })
            .addCase(fetchUsers.fulfilled, (state, action) => {
                state.minimal.status = "idle";
                state.minimal.data = action.payload ?? [];
                state.minimal.error = null;
            })
            .addCase(fetchUsers.rejected, (state, action) => {
                state.minimal.status = "failed";
                state.minimal.data = [];
                state.minimal.error = action.payload as string;
            })
            .addCase(deleteUser.fulfilled, (state, action) => {
                state.minimal.data = state.minimal.data.filter(
                    (user) => user.id !== action.meta.arg
                );
            });

    },
});

export default usersSlice.reducer;
